export default {
    data: () => ({
        translations: {
            title: {
                el: "",
                en: "Reward Options",
                it: ""
            },
            info: {
                el: "",
                en: `Set the reward options for each store of yours or redirect inside the store platform to control how will reward your clients.
                    If you need to add or remove a store please go to the store page`,
                it: ""
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            pointsAttributionType: {
                el: "Points Attribution Type",
                en: "Points Attribution Type",
                it: "Points Attribution Type"
            },
            pointsAttributionSettings: {
                el: "Points Attribution Settings",
                en: "Points Attribution Settings",
                it: "Points Attribution Settings"
            },
            enableIoTDeviceUsage: {
                el: "Enable IoT Device Usage",
                en: "Enable IoT Device Usage",
                it: "Enable IoT Device Usage"
            },
            IoTDeviceSettings: {
                el: "IoT Device Settings",
                en: "IoT Device Settings",
                it: "IoT Device Settings"
            },
            mobilePayments: {
                el: "Mobile Payments",
                en: "Mobile Payments",
                it: "Mobile Payments"
            },
            orders: {
                el: "Orders",
                en: "Orders",
                it: "Orders"
            },
            receiptScanning: {
                el: "Receipt Scanning",
                en: "Receipt Scanning",
                it: "Receipt Scanning"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            change: {
                el: "Αλλαγή",
                en: "Change",
                it: "Cambia"
            },
        }
    })
};
